<template>
    <b-container fluid>
        <b-row class="justify-content-center">
            <b-col cols="12" md="7" lg="4" class="cust-form">
                <div class="LoginForm">

                    <div class="LoginForm-form my-3 px-3">
                     <div class="LoginForm-logo">
                        <img :src="srcLogo" alt="logo"/>
                    </div>
                        <h1
                                class="text-primary mb-3 text-uppercase text-center">
                            società sportive
                        </h1>
                        <inter-input class="mb-3"
                                     label="Email"
                                     v-model="username"
                                     name="email"
                                     icon="mail"
                                     :error="errors.username">
                        </inter-input>
                        <inter-input class="mb-3"
                                     label="Password"
                                     v-model="password"
                                     type="password"
                                     name="password"
                                     icon="key"
                                     :error="errors.password">
                        </inter-input>
                        <inter-button
                                class="my-3"
                                label="login"
                                @onClick="login()">
                        </inter-button>
                        <b-table-simple responsive class="login-links-table mt-4">
                            <b-tbody>
                                <b-tr>
                                    <b-td class="text-center align-middle">
                                        <span class="setCursorPointer login-link-primary" v-on:click="$router.push({ name : 'auth.register'})">REGISTRATI</span><br>
                                        <span class="setCursorPointer login-link-secondary" v-on:click="() => { showModal = true }">Password dimenticata ?</span>
                                    </b-td>
                                    <b-td class="text-center align-middle">
                                        <span class="setCursorPointer login-link-primary">ACCESSIBILITÀ</span><br>
                                        <a
                                            class="setCursorPointer login-link-secondary"
                                                href="https://www.inter.it/aas/link?id=1415"
                                                title="Dichiarazione di accessibilità"  target="_blank"  rel="noopener noreferrer">
                                            Leggi tutto
                                        </a>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </div>
            </b-col>
        </b-row>
        <inter-modal
                title-icon="flaticon-key"
                :buttonPrimary="buttonPrimary"
                title="Invia Reset password"
                size="md"
                :visible="showModal"
                @onPrimaryClick="recoveryPassword">
            <b-container>
                <b-row>
                    <b-col cols="12">
                        <p>
                            Inserisci la tua email per ricevere una password di ripristino.<br>
                            Al tuo prossimo accesso, ricordati di aggiornarla per garantire una maggiore riservatezza
                            dei tuoi dati
                        </p>
                    </b-col>
                    <b-col cols="12">
                        <inter-input
                                placeholder="Email"
                                v-model="recoveryEmail"
                                name="recoveryEmail"
                                icon="mail">
                        </inter-input>
                    </b-col>
                </b-row>
            </b-container>
        </inter-modal>
    </b-container>
</template>

<script>

    import {mapGetters, mapActions} from 'vuex'
    import InterInput from "../../../../components/form/inter-input/InterInput";
    import InterButton from "../../../../components/form/inter-button/InterButton";
    import InterModal from "../../../../components/modal/InterModal";
    import _ from "lodash";

    export default {
        name: "loginView",
        components: {InterModal, InterButton, InterInput},

        // Google Tag Manager in <head>
        metaInfo: {
            script: [
                {
                    vmid: 'gtm-script',
                    innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-WDHKX9');`,
                    type: 'text/javascript'
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'gtm-script': ['innerHTML']
            }
        },

        computed: {
            ...mapGetters([
                'isLoggedIn'
            ]),

        },
        data() {
            return {
                errors: {},
                username: '',
                password: '',
                srcLogo: require('@/assets/media/logo.svg'),
                showModal: false,
                buttonPrimary: {
                    label: 'Invia reset',
                    confirm: true
                },
                recoveryEmail: null
            }
        },
        mounted() {

            this.injectGtmInHead();

            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
            });

            if (this.isLoggedIn) {
                this.authCurrentUser()
                    .then((data) => {
                        if (data.role === 'admin') {
                            this.$router.push({name: 'admin.matches.list'})
                        } else {
                            this.$router.push({name: 'society.dash'})
                        }

                    })
                    .catch()
            }
        },
        beforeDestroy() {
            const gtmScript = document.getElementById('gtm-head-script');
            if (gtmScript) {
                gtmScript.remove();
            }
        },
        methods: {
            ...mapActions({
                authLogin: 'authLogin',
                authCurrentUser: 'authCurrentUser',
                authRecoveryPasswordByEmail: 'authRecoveryPasswordByEmail'
            }),

            injectGtmInHead: function () {
                if (document.getElementById('gtm-head-script')) {
                    return;
                }

                const script = document.createElement('script');
                script.id = 'gtm-head-script';
                script.text = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
                    "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
                    "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
                    "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
                    "})(window,document,'script','dataLayer','GTM-WDHKX9');";

                document.head.appendChild(script);
            },

            login: function () {
                if(this.validate()) {
                    this.authLogin({
                        username: this.username,
                        password: this.password
                    })
                        .then((data) => {
                            if (data.user.role === 'admin') {
                                this.$router.push({name: 'admin.matches.list'})
                            } else {
                                this.$router.push({name: 'society.dash'})
                            }
                        })
                        .catch( () =>{
                            this.$bvToast.toast('Nome utente e password non corretti', {
                                title: 'Alert',
                                variant: 'warning'
                            });
                        })
                }

            },

            recoveryPassword: function () {
                this.authRecoveryPasswordByEmail({email: this.recoveryEmail})
                    .then(() => {
                        this.$bvToast.toast('Nuova password inviata', {
                            title: 'Success',
                            variant: 'success'
                        });
                        this.showModal = false;
                    }).catch(() => {
                    this.$bvToast.toast('Password non resettata', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    this.showModal = false;
                })
            },
            validate: function() {
                this.errors = {};
                if (this.password === '') {
                    this.errors.password = true;
                    this.$bvToast.toast('Devi darmi una password', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }

                if (this.username === '') {
                    this.errors.username = true;
                    this.$bvToast.toast('Devi darmi un nome utente', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }

                return _.isEmpty(this.errors);
            }

        },
    }
</script>

<style scoped lang="scss">
.login-links-table {
    width: 100%;
    table-layout: fixed;
}

.login-links-table td {
    border: none;
    padding: 0.5rem;
}

.login-links-table .setCursorPointer,
.login-links-table a {
    color: #fff;
    text-decoration: none;
}

.login-links-table .setCursorPointer:hover,
.login-links-table a:hover {
    color: #fff;
    text-decoration: underline;
}

.login-links-table .login-link-primary {
    font-size: 1.2rem;
    font-weight: 600;
}

.login-links-table .login-link-secondary {
    font-size: 0.9rem;
}
</style>
